import { useEffect, useLayoutEffect, useRef } from 'react';

/**
 * Tells `onChange` about `value` when the value changes, never because the callback is a new
 * function this render; linked charts pass inline callbacks, which would otherwise echo every render
 * and undo each other.
 */
export function useReport<T>(value: T, onChange: ((value: T) => void) | undefined): void {
  const latest = useRef(onChange);
  useLayoutEffect(() => {
    latest.current = onChange;
  });
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    latest.current?.(value);
  }, [value]);
}
